import React from 'react'

import { Icon, CubeAIOutline, CubeOutline, Image2, ImageAI } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string, bool } from 'prop-types'

const ICON_SIZE = { width: '20', height: '20' }

// String icon keys (from the backend `create_ai_menu`) -> Triangle UI glyphs.
const ICON_MAP = { cube_ai: CubeAIOutline, image_ai: ImageAI, cube: CubeOutline, image: Image2 }

function Section({ title, links, isSignedIn = false }) {
  return (
    <div className="unified-nav__dropdown-section unified-nav__dropdown-section--compact">
      <p className="unified-nav__dropdown-heading cgt-overline-md">{title}</p>
      <ul className="unified-nav__dropdown-list">
        {links.map((link) => {
          const IconComponent = ICON_MAP[link.icon]

          return (
            <li key={link.id} className="unified-nav__dropdown-item">
              <a
                className="unified-nav__dropdown-link cgt-body-base-semibold"
                href={isSignedIn ? link.href : link.landingHref || link.href}
                data-track-label="Create with AI"
                data-track-text={link.trackText}
              >
                <span className="unified-nav__dropdown-item-icon">
                  {IconComponent && (
                    <Icon notSpaced color="dark" size={ICON_SIZE} svgComponent={IconComponent} />
                  )}
                </span>
                <span className="unified-nav__dropdown-item-label">{link.title}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

Section.propTypes = {
  title: string.isRequired,
  links: arrayOf(shape({
    id: string,
    href: string,
    landingHref: string,
    title: string,
    trackText: string,
    icon: string,
  })).isRequired,
  isSignedIn: bool,
}

export default Section
